/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Invalid_BodyInputs */

const vi_error_irrigation_schedule_invalid_body = /** @type {(inputs: Error_Irrigation_Schedule_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dữ liệu lịch tưới không hợp lệ, vui lòng tải lại trang rồi thử lại`)
};

/**

* @param {Error_Irrigation_Schedule_Invalid_BodyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_invalid_body = /** @type {((inputs?: Error_Irrigation_Schedule_Invalid_BodyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Invalid_BodyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_invalid_body(inputs)
});